import React, { useState } from 'react';
import Intro from './components/Intro';
import ServiceForm from './components/ServiceForm';
import Results from './pages/Results';
import DashboardLayout from './components/dashboard/DashboardLayout';
import CanadaDashboard from './pages/CanadaDashboard';
import ServicesPage from './pages/ServicesPage';

type Page = 'home' | 'dashboard' | 'services';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [answers, setAnswers] = useState<any | null>(null);
  const [activeSection, setActiveSection] = useState('overview');

  const handleNavigate = (page: string) => {
    setCurrentPage(page as Page);
    // Reset to overview when navigating to dashboard
    if (page === 'dashboard') {
      setActiveSection('overview');
    }
  };

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return (
          <CanadaDashboard 
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
          />
        );
      
      case 'services':
        return <ServicesPage />;
      
      case 'home':
      default:
        return (
          <main style={styles.container}>
            <Intro />

            {!answers && (
              <ServiceForm onComplete={setAnswers} />
            )}

            {answers && (
              <Results answers={answers} />
            )}
          </main>
        );
    }
  };

  return (
    <DashboardLayout 
      currentPage={currentPage} 
      onNavigate={handleNavigate}
      activeSection={activeSection}
      onSectionChange={handleSectionChange}
    >
      {renderPage()}
    </DashboardLayout>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: 960,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
};

export default App;
